<template>
  <!-- <Block class="w-3/4"> -->
  <Block class="w-full">
    <div class="flex flex-col w-full gap-5">
      <div class="flex items-start justify-between">
        <ChartHeader
          img="/icon/dollar.png"
          title="Fees Generated"
          :amount="`$${ethRewardsTotalOverallUSDFormatted}`"
        />
        <!-- <div class="flex flex-col items-end">
          <h1 class="text-success">12.6%</h1>
          <p>Last month 230,000</p>
        </div> -->
      </div>
      <BarChart
        :chartData="chartData"
        :options="chartOptions"
        :width="250"
        :height="250"
      />
    </div>
  </Block>
</template>

<script>
import { mapGetters } from "vuex";
import { BarChart } from "vue-chart-3";
import { Chart, registerables } from "chart.js";
import Block from "../global/Block.vue";
import ChartHeader from "./ChartHeader.vue";
Chart.register(...registerables);
export default {
  name: "PlatformRevenueChart",
  components: {
    BarChart,
    Block,
    ChartHeader,
  },
  computed: {
    ...mapGetters([
      "ethRewardsTotalOverallUSDFormatted",
      "feesDataPerMonth",
    ]),

    chartData() {
      return {
        labels: this.feesDataPerMonth.map((i) => i.month),
        datasets: [
          {
            label: "Fees ($)",
            data: this.feesDataPerMonth.map((i) => i.feesUSD),
            backgroundColor: "#1F7BF4",
          },
          // {
          //   label: "",
          //   data: [25, 30, 100, 90, 10, 30, 10, 90, 100],
          //   backgroundColor: "#00AAFF",
          // },
        ],
      };
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            display: false,
          },
        },
        borderRadius: 50,
        barThickness: 20,
        borderColor: "#141519",
        borderWidth: 5,
      };
    },
  },
};
</script>
